import React from "react";
import {
    Box,
    Button,
    IconButton,
    Modal,
    Typography,
    Fade,
    Backdrop
} from "@mui/material";
import micicon from "../Assets/images/Mike - Copy.png";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

export default function VoiceInput({ setNewRecipe }) {
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    const handleMicToggle = () => {
        if (listening) {
            SpeechRecognition.stopListening();
            if (transcript && setNewRecipe) {
                setNewRecipe(transcript.trim());
            }
        } else {
            resetTranscript();
            SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
        }
    };

    const handleCancel = () => {
        SpeechRecognition.stopListening();
        resetTranscript();
        setNewRecipe("");
    };

    if (!browserSupportsSpeechRecognition) {
        return <Typography color="error">Your browser does not support speech recognition.</Typography>;
    }

    return (
        <>
            {/* Mic Floating Button */}
            <IconButton
                onClick={handleMicToggle}
                sx={{
                    width: 60,
                    height: 60,
                    backgroundColor: listening ? "#e8f5e9" : "#f5f5f5",
                    border: listening ? "2px solid #4caf50" : "1px solid #ccc",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        backgroundColor: "#eeeeee"
                    },
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    animation: listening ? "pulse 1s infinite" : "none"
                }}
            >
                <img src={micicon} alt="Mic" style={{ width: 28, height: 28 }} />
            </IconButton>

            {/* Listening Dialog */}
            <Modal
                open={listening}
                onClose={handleMicToggle}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 300 } }}
            >
                <Fade in={listening}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "90%",
                            maxWidth: 420,
                            bgcolor: "background.paper",
                            borderRadius: 3,
                            boxShadow: 24,
                            p: 4,
                            textAlign: "center"
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }} style={{
                            fontFamily: "'Poppins', sans-serif",

                        }}>
                            Voice Input
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 400,
                        }}>
                            Speak now. Click "Stop" when you're done.
                        </Typography>

                        <Box
                            sx={{
                                p: 2,
                                backgroundColor: "#f1f1f1",
                                borderRadius: 2,
                                maxHeight: 150,
                                overflowY: "auto",
                                fontSize: 15,
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 400,
                                whiteSpace     : "pre-wrap",
                                color: "#333",
                                border: "1px solid #ddd",
                                mb: 3
                            }}
                        >
                            {transcript || "Listening..."}
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                            <Button
                                variant="outlined"
                                onClick={handleCancel}
                                color="inherit"
                                fullWidth
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleMicToggle}
                                color="success"
                                fullWidth
                            >
                                Stop & Use
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}
